import React from 'react'

import { TableCell, TableSortLabel, Tooltip } from '@mui/material'

import type { ColumnConfig } from './types'

type TableHeaderCellProps = {
  cell: ColumnConfig
  sortBy?: string
  sortOrder?: string
  onSort?: (...args: any[]) => any
}

const TableHeaderCell = ({ cell, sortOrder, sortBy, onSort }: TableHeaderCellProps) => (
  <TableCell align={cell.align || 'left'} className="table__cell" component="td" style={cell.headerStyle}>
    {cell.sort ? (
      <Tooltip enterDelay={300} placement="bottom" title="Sort">
        <TableSortLabel active={sortBy === cell.sort} direction={sortOrder as any} onClick={onSort?.(cell.sort)}>
          {cell.title}
        </TableSortLabel>
      </Tooltip>
    ) : (
      cell.title
    )}
  </TableCell>
)

export default TableHeaderCell
